/* eslint-disable */

jQuery(function($) {
  const five9 = $('#five9');

  if (Object.keys(five9).length !== 0) {
    const script = document.createElement( 'script' );
    script.src = '//app.five9.com/consoles/SocialWidget/five9-social-widget.min.js';
    script.defer = true;
    document.body.appendChild( script );
  }
  let Config = {
    "rootUrl": "https://app.five9.com/consoles/",
    "type": "chat",
    "title": "Chat with Support",
    "tenant": "Hitachi Vantara Federal",
    "profiles": "Chat Campaign",
    "showProfiles": false,
    "autostart": true,
    "ga": "G-1CE4TMMNX1",
    "theme": "flagship.css",
    "surveyOptions": {
      "showComment": true,
      "requireComment": false
    },
    "fields": {
      "name": {
        "value": "",
        "show": true,
        "label": "Name"
      },
      "email": {
        "value": "",
        "show": true,
        "label": "Email"
      },
      "Phone": {
        "value": "",
        "show": true,
        "label": "Phone",
        "required": false
      }
    },
    "playSoundOnMessage": true,
    "allowCustomerToControlSoundPlay": true,
    "showEmailButton": true,
    "hideDuringAfterHours": true,
    "useBusinessHours": false,
    "showPrintButton": true,
    "allowUsabilityMenu": true,
    "enableCallback": false,
    "callbackList": "",
    "allowRequestLiveAgent": true
  };

  function onOpenChatLink(){
    let props = 'width=350,height=550,location=no,menubar=no,resizable=yes,scrollbars=no,status=no,titlebar=no,toolbar=no';
    let url = Config.rootUrl + 'ChatConsole';
    let elementCounter = 0;
    for (let key in Config) {
      url = url + (elementCounter++ === 0 ? '?' : '&');
      if (Config.hasOwnProperty(key)) {
        if(key == "fields") {
          url = url + key + '=' + JSON.stringify(Config.fields);
        } else if(key == "surveyOptions") {
          url = url + key + '=' + JSON.stringify(Config.surveyOptions);
        } else {
          url = url + key + '=' + Config[key];
        }
      }
    }
    let chatUrl = encodeURI(url);
    window.open(chatUrl, '  Chat', props)
  }

  $('footer button.shadow-chat, a[href="#chat"]').click(function(event) {
    onOpenChatLink();
    event.preventDefault();
  });
});
